import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Procedure } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

type ProcedureListResult = { hits: Procedure[]; total: number; page: number }

const LIST_QUERY = graphql(`
  query Procedures($search: String, $pagination: PaginationInput, $sort: SortInput) {
    procedures(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        locationId
        vendor
        vendorId
        patientId
        providerId
        procedureCode
        description
        tooth
        state
        priority
        feeAmount
        billedAmount
        appointmentIds
        planIds
        procedureCreateDate
        procedureUpdateDate
        createdDate
        updatedDate
        version
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query Procedure($id: ID!) {
    procedure(id: $id) {
      id
      orgId
      workspaceId
      locationId
      vendor
      vendorId
      patientId
      providerId
      procedureCode
      description
      tooth
      state
      priority
      feeAmount
      billedAmount
      appointmentIds
      planIds
      procedureCreateDate
      procedureUpdateDate
      createdDate
      updatedDate
      version
    }
  }
`)

export class ProcedureStore extends EntityStore<Procedure, ProcedureListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.procedures,
      extractOne: (data: any) => data.procedure,
    })
  }
}
